module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tofu-dropdown",
    on: {
      "mouseover": _vm.onMouseover,
      "mouseleave": _vm.onMouseleave
    }
  }, [_c('v-button', {
    attrs: {
      "label": _vm.label,
      "state": _vm.showPanel
    },
    nativeOn: {
      "click": function($event) {
        _vm.togglePanel()
      }
    }
  }, [_c('div', {
    staticClass: "dropdown-button-icon",
    attrs: {
      "slot": "tail"
    },
    slot: "tail"
  }, [_c('v-icon', {
    attrs: {
      "iconClass": "tofu-icon icon-arrow-down",
      "size": 9
    }
  })], 1)]), _vm._v(" "), _c('v-panel', {
    class: (_vm.pos + " pos"),
    attrs: {
      "toggle": _vm.showPanel,
      "lazy": true
    },
    nativeOn: {
      "click": function($event) {
        _vm.hidePanel($event)
      }
    }
  }, [_vm._t("default")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-76c242d4!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/tofu-dropdown/src/dropdown.vue
// module id = 667
// module chunks = 0